<template>
  <transition name="sagepay-detail">
    <div class="sagepay-show">
      <article id="page-sagepay">
        <div class="page-body">
          <section>
            <div id="sagepayPageHeader">
              <div id="startStoreLogoCol" v-if="this.store_data.logo">
                <div class="fixBg"></div>
                <div class="logo-col">
                  <img src="@/assets/images/s.gif" :style="{ backgroundImage: 'url(' + this.store_data.logo + ')' }" />
                </div>
              </div>

              <div class="title" :class="{'hasLogo':this.store_data.logo}">{{ this.store_data.store_name }}</div>
            </div>

            <div id="sagepayModalBody">
              <form method="post" id="sagePayForm">
                <ul class="payFormBox">
                  <li class="inputGridCol">
                    <div class="input-group">
                      <input class="input-item" required id="firstName" name="firstName" type="text"
                        v-model="sagePayForm.firstName" data-card-details="cardholder-firstName"
                        placeholder="First Name" />
                      <input class="input-item" required id="lastName" name="lastName" type="text"
                        v-model="sagePayForm.lastName" data-card-details="cardholder-lastName"
                        placeholder="Last Name" />
                      <a-icon type="user" />
                      <a-icon type="solution" />
                    </div>
                  </li>
                  <li>
                    <div class="input-group">
                      <input class="input-item" required id="card" name="card" type="text" v-model="card"
                        @keyup="inputCard" @paste="inputCard" data-card-details="card-number"
                        placeholder="Card number" />
                      <a-icon type="credit-card" />
                    </div>
                  </li>
                  <li class="inputGridCol">
                    <div class="input-group">
                      <input class="input-item" required id="expiry" name="expiry" type="text" maxlength="7"
                        v-model="expiry" placeholder="MM / YY" @keyup="inputDate" @paste="inputDate"
                        data-card-details="expiry-date" />
                      <input class="input-item" required id="cvc" name="cvc" type="text" maxlength="3"
                        v-model="sagePayForm.cvc" @keyup="inputCVC" @paste="inputCVC" data-card-details="security-code"
                        placeholder="CVC" />
                      <a-icon type="calendar" />
                      <a-icon type="lock" />
                    </div>
                  </li>
                </ul>

                <div class="searchCol">
                  <vue-google-autocomplete id="map" placeholder="Enter to search your address, E.g: NE14XF"
                    @placechanged="getAddressData" types="geocode">
                  </vue-google-autocomplete>
                  <a-icon type="search" />
                </div>
                <ul class="payFormBox" id="billAcountForm">
                  <li>
                    <div class="input-group">
                      <input class="input-item" required id="postalCode" name="postalCode" type="text"
                        v-model="postalCode" placeholder="Post Code" data-card-details="postalCode"
                        @keypress="inputPostCode" @keyup="inputPostCode" @paste="inputPostCode" maxlength="8"
                        autocomplete="off" />
                      <a-icon type="mail" />
                    </div>
                  </li>

                  <li>
                    <div class="input-group" id="withAreaCode">
                      <country v-model="sagePayForm.country" :value="sagePayForm.country"></country>
                      <div id="areaCodeValue"></div>
                      <a-icon type="global" />
                    </div>
                  </li>

                  <li>
                    <div class="input-group">
                      <input class="input-item" required id="city" name="city" type="text" v-model="sagePayForm.city"
                        placeholder="City" data-card-details="city" />
                      <a-icon type="environment" />
                    </div>
                  </li>

                  <li>
                    <div class="input-group">
                      <input class="input-item" required id="address1" name="address1" type="text"
                        v-model="sagePayForm.address1" placeholder="Address" data-card-details="address1" />
                      <a-icon type="home" />
                    </div>
                  </li>
                </ul>
                <input type="hidden" name="card-identifier" />
              </form>

              <button id="sagePaySubmit" class="btn" @click="sagePaySubmit" type="submit">
                Pay &pound;<span>{{ (priceTotal/100).toFixed(2) }}</span>
              </button>
              <template v-if="pay3DAuth.status == '3DAuth' && pay3DAuth.acsUrl && pay3DAuth.cReq">
                <form id="pay-3d-auth-cre-form" method="post" :action="pay3DAuth.acsUrl" target="">
                  <input type="hidden" name="creq" :value="pay3DAuth.cReq">
                  <input type="hidden" name="threeDSSessionData" :value="pay3DAuth.transactionId">
                </form>
              </template>

              <template v-if="pay3DAuth.status == '3DAuth' && pay3DAuth.acsUrl && pay3DAuth.paReq">
                <form id="pay-3d-auth-pa-form" method="post" :action="pay3DAuth.acsUrl" target="">
                  <input type="hidden" name="PaReq" :value="pay3DAuth.paReq">
                  <input type="hidden" name="MD" :value="pay3DAuth.transactionId">
                  <input type="hidden" name="TermUrl" :value="pay3DAuth.termUrl">
                </form>
              </template>
              <Pay3DSAuth :style="{ 'display': pay3DAuth.modalPay3DSAuth ? 'block' : 'none' }"></Pay3DSAuth>
            </div>
          </section>
        </div>


      </article>
    </div>

  </transition>
</template>

<script>
import $ from "jquery";
import axios from 'axios';
import Country from "@/components/Country";
import VueGoogleAutocomplete from "@/components/vue-google-autocomplete";
import Pay3DSAuth from '../components/modal/Pay3DSAuth'

export default {
  name: "Opayo",
  components: {
    Country,
    VueGoogleAutocomplete,
    Pay3DSAuth,
  },
  props: [
    "storeLogo", "storeName", "depositPrice", 'modalShow', 'reservation_id'
  ],
  data() {
    return {
      //			fold: true,
      showFlag: false,
      sagePayForm: {
        firstName: "",
        lastName: "",
        card: "",
        expiry: "",
        cvc: "",
        cardIdentifier: "",
        country: "GB",
        city: "",
        postalCode: "",
        address1: "",
        address2: "",
      },
      pay3DAuth: {
        "status": "",
        "statusCode": "",
        "statusDetail": "",
        "transactionId": "",
        "acsUrl": "",
        "cReq": "",
        "threeDSSessionData": "",
        "paReq": "",
        "termUrl": process.env.PAY3DAUTH_TERMURl,
        modalPay3DSAuth: false,
      },
      firstName: "",
      card: "",
      lastName: "",
      expiry: "",
      cvc: "",
      postalCode: "",
      cardIdentifier: "",
      sageCardSessionKey: "",
      sagepaySelectCard: false,
      sagepaycheckoutData: "",
      sagePayFormDefault: {
        cvc: "",
      },
      rememberCardFlag: 0,
      googleResult: [],
      storeInfo: {},
      sagePaySessionKey: '',
      sageCards: [

      ],
      offerTotal: 0,
      orderTotal: 0,
      fromRouter: '',
      offerName: "",
      offerNumber: 1,
      useVoucherId: '',
      choosedCard: undefined,
      order_id: '',
      selectCard_id: '',
      priceTotal: '',
      store_data:''
    };
  },

  computed: {

  },
  created() {
    this.priceTotal = localStorage.getItem('priceTotal')
    this.store_data = JSON.parse(localStorage.getItem('store_data'))
    console.log(this.store_data)
  },
  methods: {
    getPay3DAuth(res) {
      // 获取支付状态：开始
      console.log("获取支付状态: " + JSON.stringify(res, null, 4));
      console.log("pay3DAuth.termUrl: " + this.pay3DAuth.termUrl);

      if (res.data.status == "Ok") {
        console.log("res.data.status: " + res.data.status);
        this.$router.push({ path: "/receipt" });
      }
      else if (
        res.data.status == "3DAuth" &&
        res.data.acsUrl &&
        res.data.cReq
      ) {
        if (
          !this.pay3DAuth.status ||
          !this.pay3DAuth.acsUrl ||
          !this.pay3DAuth.cReq ||
          !this.pay3DAuth.transactionId
        ) {
          this.$set(this.pay3DAuth, "status", res.data.status);
          this.$set(this.pay3DAuth, "acsUrl", res.data.acsUrl);
          this.$set(this.pay3DAuth, "cReq", res.data.cReq);
          this.$set(this.pay3DAuth, "transactionId", res.data.transactionId);
        } else {
          this.pay3DAuth.status = res.data.status;
          this.pay3DAuth.acsUrl = res.data.acsUrl;
          this.pay3DAuth.cReq = res.data.cReq;
          this.pay3DAuth.transactionId = res.data.transactionId;
        }

        this.$nextTick(function () {
          let form = document.getElementById("pay-3d-auth-cre-form");
          form.elements["creq"].value = this.pay3DAuth.cReq;
          form.elements["threeDSSessionData"].value = this.pay3DAuth.transactionId;
          form.action = this.pay3DAuth.acsUrl;

          console.log("threeDSSessionData: " + form.elements["threeDSSessionData"].value);
          console.log("creq: " + form.elements["creq"].value);
          console.log("acsUrl: " + form.action);

          form.submit();
        });
      }
      else if (
        res.data.status == "3DAuth" &&
        res.data.acsUrl &&
        res.data.paReq
      ) {

        // pay3DAuth: {
        //   "status": "",
        //   "transactionId": "",
        //   "acsUrl": "",
        //   "paReq": "",
        //   "termUrl": "",
        // },

        let TermUrl = this.pay3DAuth.termUrl;
        TermUrl += "?PaReq=" + res.data.paReq;
        TermUrl += "&MD=" + res.data.transactionId;

        //   !this.pay3DAuth.status ||
        //   !this.pay3DAuth.acsUrl ||
        //   !this.pay3DAuth.cReq ||
        //   !this.pay3DAuth.transactionId

        if (
          !this.pay3DAuth.status ||
          !this.pay3DAuth.acsUrl ||
          !this.pay3DAuth.termUrl ||
          !this.pay3DAuth.transactionId ||
          !this.pay3DAuth.paReq
        ) {
          this.$set(this.pay3DAuth, "status", res.data.status);
          this.$set(this.pay3DAuth, "acsUrl", res.data.acsUrl);
          this.$set(this.pay3DAuth, "termUrl", TermUrl);
          this.$set(this.pay3DAuth, "transactionId", res.data.transactionId);
          this.$set(this.pay3DAuth, "paReq", res.data.paReq);
        } else {
          this.pay3DAuth.status = res.data.status;
          this.pay3DAuth.acsUrl = res.data.acsUrl;
          this.pay3DAuth.termUrl = TermUrl;
          this.pay3DAuth.transactionId = res.data.transactionId;
          this.pay3DAuth.paReq = res.data.paReq;
        }

        console.log("acsUrl: " + this.pay3DAuth.acsUrl);
        console.log("transactionId: " + this.pay3DAuth.transactionId);
        console.log("PaReq: " + this.pay3DAuth.paReq);

        this.$nextTick(function () {
          let form = document.getElementById("pay-3d-auth-pa-form");
          form.elements["TermUrl"].value = this.pay3DAuth.termUrl;
          form.elements["PaReq"].value = this.pay3DAuth.paReq;
          form.elements["MD"].value = this.pay3DAuth.transactionId;
          form.action = this.pay3DAuth.acsUrl;

          console.log("TermUrl: " + form.elements["TermUrl"].value);
          console.log("PaReq: " + form.elements["PaReq"].value);
          console.log("MD: " + form.elements["MD"].value);
          console.log("paForm.action: " + form.action);

          form.submit();
          this.SetLoading(true);
        });
      }
      else if (
        res.data.status != "Ok" ||
        res.data.status != "3DAuth"
      ) {


        if (!this.pay3DAuth.modalPay3DSAuth) {
          this.$set(this.pay3DAuth, "modalPay3DSAuth", true);
        } else {
          this.pay3DAuth.modalPay3DSAuth = true;
        }
      }
      // 获取支付状态：结束
    },
    closeView() {
      this.$parent.modalShow = false;
      this.sagePayForm.firstName = "";
      this.sagePayForm.lastName = "";
      this.sagePayForm.card = "";
      this.sagePayForm.expiry = "";
      this.sagePayForm.cvc = "";
      this.$forceUpdate();

    },

    checkCheckBox() {
      if (event.target.checked) {
        this.rememberCardFlag = 1;
      } else {
        this.rememberCardFlag = 0;
      }
    },
    inputCard() {
      this.sagePayForm.card = this.card.replace(/\s/g, "");
      this.card = this.card.replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
    },
    inputDate() {
      this.sagePayForm.expiry = this.expiry.replace(/\s\/\s/g, "");
      this.expiry = this.expiry
        .replace(/\D/g, "")
        .replace(/(\d{2})(?=\d)/g, "$1 / ");
    },
    inputCVC() {
      this.sagePayForm.cvc = this.sagePayForm.cvc.replace(/\D/g, "");
    },
    inputCVC2() {
      this.sagePayFormDefault.cvc = this.sagePayFormDefault.cvc.replace(
        /\D/g,
        ""
      );
    },
    inputPostCode() {
      this.sagePayForm.postalCode = this.postalCode.replace(/\s/g, "");
      this.postalCode = this.postalCode
        .replace(/[^\w]/gi, "")
        .replace(/(\d{3})(?=\d)/g, "$1 ");
    },
    getAddressData(value) {

      this.postalCode = value.postal_code;
      this.sagePayForm.postalCode = value.postal_code;
      this.sagePayForm.country = value.country;
      if (value.postal_town) {
        this.sagePayForm.city = value.postal_town;
      } else {
        this.sagePayForm.city = value.locality;
      }

      if (value.street_number) {
        this.sagePayForm.address1 = value.street_number + " " + value.route;
      } else {
        this.sagePayForm.address1 = value.route;
      }

      this.countrySelect();
      $("#billAcountForm input").removeClass("has-danger");
    },
    loadSage() {
      ((d, s, id) => {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          this.sagepay_load = false;
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://pi-test.sagepay.com/api/v1/js/sagepay.js";
        fjs.parentNode.insertBefore(js, fjs);
        js.onload = () => {
          this.sagepay_load = false;
        };
      })(document, "script", "sagepayJS");
    },
    sagePaySubmit() {
      this.$parent.loadingShow = true
      let form = $("#sagePayForm");
      $("#sagePayForm").valid();
      if (!form.valid()) {
        this.$parent.loadingShow = false
      } else {

        let sub_data = {
          model_key: 1, //没有卡
          f_name: this.sagePayForm.firstName,
          l_name: this.sagePayForm.lastName,
          rememberCardFlag: 0,//this.rememberCardFlag
          card_number: this.sagePayForm.card,
          bill_address: this.sagePayForm.address1,
          bill_country: this.sagePayForm.country,
          bill_postalCode: this.sagePayForm.postalCode,
          expriy_date: this.sagePayForm.expiry,
          bill_city: this.sagePayForm.city,
          cvc: this.sagePayForm.cvc,
        };
        sub_data.reserve_id = localStorage.getItem('reservation_id')
        sub_data.amount = localStorage.getItem('depositPrice')
        sub_data.source = 1
        sub_data.store_id = localStorage.getItem('store_id')

        axios.post(process.env.API_URL + 'htmlReserve/selfPayment', sub_data).then(res => {
          console.log(res.data)
          if (res.data.code == 200) {

            // 获取支付状态：开始
            this.getPay3DAuth(res.data);
            // 获取支付状态：结束
            localStorage.setItem('priceTotal', '')
            localStorage.setItem('reservation_id', '')
            localStorage.setItem('opayo_set_status', '')
            localStorage.setItem('viva_set_status', '')
            localStorage.setItem('depositPrice', '')
            localStorage.setItem('store_id', '')
            localStorage.setItem('store_data', '')
            

            if (this.fromRouter == 1) {
              this.$router.push({
                path: "/offers/sucess/" + this.offerName + "/" + this.offerNumber
              });


            } else if (this.fromRouter == 2 || this.fromRouter == 4) {
              this.$router.push({
                path: "/cards/sucess/" + this.membershipCar_data.name
              });



            } else {
              let payment = [{
                // amount: this.orderTotal,
                amount: Number(this.orderTotal) + Number(this.tips),
                change_type: 3,
                pay_info: "",
                payment_id: 13,
                point: 0,
                tips: this.tips,
              },];

              let postdata = {
                payment: JSON.stringify(payment),
                order_id: this.credit_id,
                voucher_user_id: this.useVoucherId
              };

            }

          } else if (res.code == 401) {

            this.$error({
              title: 'ERROR',
              content: res.message,
            });
          } else {

            this.closeView()
            // alert(res.message);
            // alert("Connection timed out, please try again");
          }

        });

      }

    },
    cardChanged(value) {
      this.sagepaySelectCard = true;
      var cardValue = `${value}`;
      console.log(value);
      this.selectCard_id = value

      if (cardValue !== "undefined") {
        this.sageCardSessionKey = cardValue;
      } else {
        this.sagepaySelectCard = false;
        this.sageCardSessionKey = "";
      }
    },
    cardSelectFirst(card) {
      console.log(card);
      this.cardChanged(card.card_identifier);
    },
    countrySelect() {
      var defaultCountry = this.sagePayForm.country;
      $("#country")
        .find("option")
        .each(function () {
          var thisCountry = $(this).data("country");
          var thisCountryCode = $(this).val();
          if (thisCountryCode == defaultCountry) {
            $(this).prop("selected", "selected");
            $("#areaCodeValue").html(thisCountry);
          }
        });

      $("#country").change(function () {
        var thisCountry = $("#country").val();
        var valCountry = $(this).find(":selected").attr("data-country");
        $("#areaCodeValue").html(valCountry);
      });
    },
  },
  mounted() {
    this.countrySelect();

    $("#sagePayForm").validate({
      rules: {
        firstName: {
          required: true,
          minlength: 1,
        },
        lastName: {
          required: true,
          minlength: 1,
        },
        card: "required",
        expiry: "required",
        cvc: {
          required: true,
          minlength: 3,
        },
        postalCode: "required",
        city: "required",
        address1: "required",
      },
      messages: {
        firstName: {
          required: "The first name cannot be empty",
          minlength: "Your first name must consist of at least 1 characters",
        },
        lastName: {
          required: "The last name cannot be empty",
          minlength: "Your last name must consist of at least 1 characters",
        },
        card: {
          required: "Card number cannot be empty",
          minlength: "Please enter a valid Card number",
        },
        cvc: {
          required: "The CVC cannot be empty",
          minlength: "Your CVC must consist of at least 3 characters",
        },
        expiry: {
          required: "The password cannot be empty",
          minlength: "Please enter a valid expiry date",
        },
        postalCode: {
          required: "The post code cannot be empty",
          minlength: "The post code must consist of at least 6 characters",
        },
        city: {
          required: "The city cannot be empty",
          minlength: "Please enter a valid city",
        },
        address1: {
          required: "The address cannot be empty",
          minlength: "Please enter a valid address",
        },
      },

      //	      errorElement: "div",
      //	      errorClass: "form-control-feedback",
      //	      errorPlacement: function (error, element) {
      //	        error.addClass("form-control-feedback");
      //	        error.insertAfter(element.parent(".input-group"));
      //	      },
      highlight: function (element, errorClass, validClass) {
        $(element)
          .parents("li")
          .addClass("has-danger")
          .removeClass("has-success");
        $(element).addClass("has-danger");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element)
          .parents("li")
          .addClass("has-success")
          .removeClass("has-danger");
        $(element).removeClass("has-danger");
      },
    });
    $("#sagePayForm2").validate({
      rules: {
        cvc: {
          required: true,
          minlength: 3,
        },
      },
      messages: {
        cvc: {
          required: "The CVC cannot be empty",
          minlength: "Your CVC must consist of at least 3 characters",
        },
      },

      highlight: function (element, errorClass, validClass) {
        $(element)
          .parents("li")
          .addClass("has-danger")
          .removeClass("has-success");
        $(element).addClass("has-danger");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element)
          .parents("li")
          .addClass("has-success")
          .removeClass("has-danger");
        $(element).removeClass("has-danger");
      },
    });
  },
};
</script>

<style>
.logo-col {
  border-radius: 50%;
}

.logo-col img {
  border-radius: 50%;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

#withAreaCode select {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  z-index: 2;
  font-size: 0;
  outline: none !important;
}

#sagepayModal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 999;
}

#sagepayModal #sagepayModalCompenent {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 450px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, .4);
}

#sagepayModal #sagepayModalCompenent #sagepayModalBody {
  position: relative;
  padding: 20px;
}

#sagePaySubmit {
  position: relative;
  width: calc(100%);
  display: block;
  margin-bottom: 20px;
  font-size: 16px;
  padding: 15px 0;
  border-radius: 8px;
  box-shadow: 5px 5px 10px rgba(5, 5, 5, .2), -3px -3px 3px rgba(6, 6, 6, .05);
  font-weight: 700;
  background: linear-gradient(to bottom right, #5D67ED, #46D7EA);
  border: none;
  color: #fff;
  text-transform: uppercase;
}

#sagePaySubmit:hover,
#sagePaySubmit:active {
  background: linear-gradient(to bottom right, #46D7EA, #5D67ED);
}

#closeStripeBtn {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  right: 5px;
  top: 5px;
  background: rgba(3, 3, 3, .2);
  border: 1px solid #dedede
}

#closeStripeBtn i {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 12px;
  color: #fff;
}

#closeStripeBtn i:before {
  text-shadow: 0 0 1px #fff;
  font-weight: 700;
}



#sagepayModalHeader {
  background: #f5f5f5;
  padding: 10px 0;
  text-align: center;
  position: relative;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #dedede;
}

#sagepayModalHeader * {
  text-shadow: 1px 1px 0 rgba(255, 255, 255, .9);
}

#sagepayModalHeader .title {
  font-size: 16px;
  color: #333;
  font-weight: 700;
  padding-top: 50px;
}

#sagepayModalHeader p {
  margin-bottom: 0;
  font-size: 12px;
}

#closeStripeBtn .close {
  position: absolute;
  left: 50%;
  top: 38%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: #fff;
  line-height: 1;
  text-shadow: none;
  float: none;
  clear: both;
}


#sagepayModalCompenent #startStoreLogoCol {
  position: absolute;
  width: 70px;
  z-index: 9;
  top: -30px;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}

#sagepayModalCompenent #startStoreLogoCol .fixBg {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

#sagepayModalCompenent #startStoreLogoCol .fixBg:after,
#sagepayModalCompenent #startStoreLogoCol .fixBg:before {
  position: absolute;
  content: "";
  z-index: 0;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 1px solid #dedede;
  background: #999;
}

#sagepayModalCompenent #startStoreLogoCol .fixBg:before {
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  background: #fff;
  box-shadow: 1px 1px 5px rgba(5, 5, 5, .2);
}



#sagePayForm ul,
#sagePayForm li {
  position: relative;
  text-align: left;
}

#sagePayForm li {
  margin-bottom: 30px;
  /* margin-bottom: 10px;*/
}

#sagePayForm label {
  position: relative;
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  font-size: 12px;
  text-transform: uppercase;
  padding-left: 15px;
}

#sagePayForm .input-group {}

#sagePayForm .inputGridCol .label {
  width: 50%;
}

#sagePayForm .inputGridCol {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-flow: dense;
  grid-column-gap: 0;
  grid-row-gap: 0px;
}

#sagePayForm .inputGridCol .input-group {
  grid-column-end: span 2;
  background: #f1f1f2;
  border-radius: 25px;
}

#sagePayForm .inputGridCol .input-group:after {
  position: absolute;
  content: "";
  width: 1px;
  height: 99%;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: #dedede;
}

#sagePayForm .inputGridCol .input-group #firstName {
  border-radius: 25px 0 0 25px;
}

#sagePayForm .inputGridCol .input-group #lastName {
  border-radius: 0 25px 25px 0;
}

#sagePayForm .inputGridCol .input-group #expiry {
  border-radius: 25px 0 0 25px;
}

#sagePayForm .inputGridCol .input-group #cvv {
  border-radius: 0 25px 25px 0;
}


#sagepayModalBody .rememberCardCol {
  text-align: left;
}

#sagepayModalBody .has-danger .form-control-feedback {
  position: absolute;
  top: 55px;
  /*top:auto;*/
  font-size: 12px;
  line-height: 1;
  margin: 0;
}

#sagepayModalBody #lastName-error,
#sagepayModalBody #cvv-error {
  top: 70px
}

#sagepayModalBody .input-item {
  height: 38px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.alreadyHasCardCol {
  position: relative;
  margin-bottom: 10px;
}

/*#sagePayForm{ height:230px; overflow-y: scroll; padding-bottom: 20px;}*/
#sagePayForm #withAreaCode {
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 0;
}

#sagePayForm #withAreaCode #areaCodeValue {
  left: auto;
  right: 0;
  width: 50%;
  height: 38px;
  line-height: 37px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 0 25px 25px 0;
  overflow: hidden;
}

#sagePayForm #areaCodeValue:before {
  background: #f1f1f2;
}

#sagePayForm #withAreaCode .input-item {
  border-radius: 25px 0 0 25px;
}



/*SagePay.vue*/
/* ≈ { padding-bottom: 200px;} */
#page-sagepay .page-body {
  position: relative;
  /*height: calc(100vh - 120px); */
  width: 100%;
  margin: 20px auto 0;
  /*background: #fff; box-shadow: 5px 5px 10px rgba(9,9,9,.1), -2px -2px 5px rgba(9,9,9,.05); border-radius: 10px;*/
}

#page-sagepay .page-body section {
  z-index: 2;
  background: #fff;
  box-shadow: 0 0 10px rgba(9, 9, 9, .8);
  border-radius: 10px;
  background: #f7f8f9;
}

#page-sagepay #sagepayPageHeader {
  background: #f5f5f5;
  background: linear-gradient(180deg, rgba(245, 245, 247, 1) 0%, rgba(220, 221, 223, 1) 100%);
  border-radius: 10px 10px 0 0;
}

#page-sagepay #sagepayPageHeader #startStoreLogoCol {
  width: 70px;
  height: 70px;
  top: -15px;
  position: relative;
  margin: auto;
}

#page-sagepay #sagepayPageHeader #startStoreLogoCol .fixBg {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

#page-sagepay #sagepayPageHeader #startStoreLogoCol .fixBg:after,
#page-sagepay #sagepayPageHeader #startStoreLogoCol .fixBg:before {
  position: absolute;
  content: "";
  z-index: 0;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 1px solid #dedede;
  background: #999;
}

#page-sagepay #sagepayPageHeader #startStoreLogoCol .fixBg:before {
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  background: #fff;
  box-shadow: 1px 1px 5px rgba(5, 5, 5, .2);
}

#page-sagepay #sagepayPageHeader .title {
  position: relative;
  text-shadow: 1px 1px 0 rgba(255, 255, 255, .9);
  font-size: 16px;
  color: #333;
  font-weight: 700;
  text-align: center;
  margin: auto;
  top: 10px;
}

#page-sagepay #sagepayPageHeader .title.hasLogo {
  top: -10px;
}

#page-sagepay #sagepayPageHeader {
  padding-bottom: 20px;
  border-bottom: 1px solid #bbbbbd;
}

#page-sagepay #sagepayModalBody {
  padding: 20px;
  position: relative;
  border-top: 1px solid #fff;
}

#page-sagepay #sagepayModalBody .formBody {
  position: relative;
}

#page-sagepay #sagepayModalBody #addressLine .input-group:first-of-type {
  margin-bottom: 10px;
}

#page-sagepay #sagepayModalBody #addressLine.has-danger .input-group:nth-of-type(2) {
  background: #f1f1f2;
}

#page-sagepay #sagepayModalBody .form-control-feedback {
  margin: 0;
}


#page-sagepay #sagepayModalBody {}

#page-sagepay .payFormBox {
  border: 1px solid #b5b5b6;
  border-radius: 5px;
  box-shadow: inset 1px 1px 2px rgba(9, 9, 9, .2), inset -1px -1px 2px rgba(9, 9, 9, .1);
  background: #fff;
  padding: 2px;
}

#page-sagepay .payFormBox li {
  margin: 0 auto;
}

#page-sagepay .payFormBox li * {
  background: transparent !important;
}

#page-sagepay .payFormBox li .input-item {
  padding-left: 30px;
  padding-right: 5px;
  width: 100%;
}

#page-sagepay .payFormBox li.inputGridCol .input-item {
  width: 50%;
}

#page-sagepay .payFormBox li i {
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
}

#page-sagepay .payFormBox li i:nth-of-type(1) {
  left: 5px;
}

#page-sagepay .payFormBox li.inputGridCol i:nth-of-type(2) {
  left: calc(50% + 5px);
}


#page-sagepay .payFormBox li i.anticon {
  margin-left: 5px;
}

#page-sagepay .payFormBox li i.icon-lastName:before,
#page-sagepay .payFormBox li i.icon-first_name:before {
  width: 22px;
  height: 22px;
  opacity: .5;
}

#page-sagepay .payFormBox li i.icon-lastName,
#page-sagepay .payFormBox li i.icon-first_name {
  opacity: 1;
}

#page-sagepay .payFormBox li input {
  border-radius: 0 !important;
  border: 1px solid #fff;
}

#page-sagepay .payFormBox li ::-webkit-input-placeholder,
#page-sagepay .payFormBox li ::placeholder,
#page-sagepay .payFormBox li :-moz-placeholder,
#page-sagepay .payFormBox li ::-moz-placeholder,
#page-sagepay .payFormBox li :-ms-input-placeholder {
  font-size: 12px !important;
  text-transform: uppercase !important;
}



#page-sagepay .payFormBox li {
  border-bottom: 1px solid #e4e4e4;
}

#page-sagepay .payFormBox li:last-of-type {
  border-bottom: none;
}


#page-sagepay #sagePayForm .payFormBox li #withAreaCode {
  position: relative;
  width: 100%;
  display: block !important;
  height: 38px;
}

#page-sagepay #sagePayForm .payFormBox li #withAreaCode select {
  position: absolute;
  width: calc(100% - 10px);
  left: 0;
}

#page-sagepay .payFormBox li #withAreaCode #areaCodeValue {
  width: 100%;
  padding-left: 30px;
  border-radius: 0;
}

#page-sagepay .payFormBox li #withAreaCode:after {
  display: none;
}

#page-sagepay .payFormBox li #areaCodeValue:before {
  background: #fff;
  right: 10px;
}

#page-sagepay .payFormBox li #areaCodeValue:after {
  right: 12px;
}

#page-sagepay .payFormBox li label.error {
  display: none !important
}

#page-sagepay .payFormBox li input.has-danger {
  background: rgba(220, 167, 183, .2) !important;
  border-color: #e2116d;
}

.searchCol {
  position: relative;
  width: 100%;
  margin: 15px 0 10px;
}

.searchCol .search-item {
  position: relative;
  width: 100%;
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-radius: 4px;
  height: 34px;
  padding: 5px 20px 5px 30px;
  font-size: 12px !important;
}

.searchCol i {
  position: absolute;
  left: 10px;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
}

.searchCol .search-item:focus {
  border-color: #40a9ff;
}

.searchCol .closeBtn {
  right: 10px;
  left: auto;
  color: #dedede;
}

.searchCol input {
  position: relative;
  width: 100%;
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 34px;
  padding: 5px 20px 5px 30px;
  font-size: 12px !important;
}

.searchCol .ant-input-affix-wrapper .ant-input-suffix {
  right: 30px;
}

#page-sagepay .rememberCardCol {
  border: 1px solid #d7d7da;
  padding: 5px 30px;
  border-radius: 5px;
  margin-bottom: 30px;
}

#page-sagepay .rememberCardCol label {
  text-transform: uppercase;
  text-shadow: 1px 1px 0 rgba(9, 9, 9, .2);
}


#page-sagepay {
  /* min-height: 120vh;min-height: 120vh; height: auto;  */
  position: relative;
  min-width: 300px;
  max-width: 390px;
  width: calc(100% - 40px);
  padding-bottom: 110px;
  margin: auto;
}

#page-sagepay .backBtn {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 11;
}

#page-sagepay .backBtn i {
  color: #fff;
  font-size: 36px;
}

#page-sagepay .backBtn span,
#page-sagepay .backBtn span:before,
#page-sagepay .backBtn span:after {
  background: #000 !important;
}

#page-sagepay .page-title {
  position: relative;
  background: #fff;
  border-bottom: 1px solid #efefef;
  padding: 10px 0;
  font-size: 16px;
  margin-bottom: 10px;
}

#page-sagepay .page-title {
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 770px;
  z-index: 10;
}

#page-sagepay {
  padding-top: 50px;
}


.sagepay-show {
  /* position: fixed; left: 0; top: 0; bottom: 0; */
  background: rgba(9, 9, 9, .7);
  /* width: 100%; */
  z-index: 999;
  position: relative;
  min-height: 100vh;
}

.sagepay-show {
  max-width: 410px;
  margin: auto;
  box-shadow: 0 5px 15px rgba(0, 0, 0, .2), 0 -5px 15px rgba(9, 9, 9, .1);
  -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, .2), 0 -5px 15px rgba(9, 9, 9, .1);
  overflow-y: scroll;
}

#page-sagepay ul,
#page-sagepay li {
  list-style: none;
}

.sagepay-detail-enter-active,
.sagepay-detail-leave-active {
  transition: 0.5s;
}

.sagepay-detail-enter,
.sagepay-detail-leave-to {
  transform: translateX(100%);
}

#page-sagepay #sagepayModalBody {
  /* max-height: calc(100vh - 300px); overflow-y: scroll; overflow-x: hidden; */
}

#page-sagepay .page-body {
  margin-bottom: 30px;
}

#page-sagepay .page-body section {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Opayo.vue